import classNames from "classnames";
import React from "react";
import styles from "./progressDots.css";

interface Props {
  totalSteps: number;
  fulfilledSteps: number;
}

export const ProgressDots: React.SFC<Props> = ({ totalSteps, fulfilledSteps }) => {
  const dots = [];
  for (let i = 0; i < totalSteps; i++) {
    dots.push(
      <div className={classNames(styles.dot, { [styles.fulfilled]: i < fulfilledSteps })} key={i} />
    );
  }
  return <div className={styles["dots-container"]}>{dots}</div>;
};
